export default {
  brand: "USFansSheet",
  nav: {
    home: "Home",
    categories: "Categories",
    guides: "Guides",
    guide: "Shopping Guide",
    faq: "FAQ",
    safety: "Safety",
    mainWebsite: "Main Website",
  },
  hero: {
    badge: "Independent buying resource",
    title: "The Smarter Way to Explore the USFans Spreadsheet",
    subtitle: "Browse organized product categories, seller information, QC guidance, shipping details and safety tips — all in one clean destination.",
    ctaPrimary: "USFans Spreadsheet",
    ctaSecondary: "Buy It Now",
    ctaGuide: "Read the USFans Guide",
    trust: "Independent resource · Updated regularly · Multilingual",
  },
  categories: {
    title: "Shop by Category",
    subtitle: "Browse every product category in the USFans Spreadsheet. Choose a category to open it on the main website.",
    dropdownLabel: "All Categories",
    dropdownHint: "Select a category",
    popularTitle: "Popular Categories",
    viewAll: "View all categories",
  },
  intro: {
    eyebrow: "What is it",
    title: "What Is the USFans Spreadsheet?",
    p1: "The USFans Spreadsheet is an organized reference that brings product listings, categories and buying details together in a simple table format. Instead of jumping between many pages, you open one place to scan items, check categories and find the links you need.",
    p2: "Our goal at USFansSheet is to make that research easier — with clear category shortcuts, honest guidance and useful tips on QC, shipping and safety, before you continue to the main resource.",
    cta: "Explore USFans Spreadsheet",
  },
  articles: {
    eyebrow: "Guides",
    title: "USFans Spreadsheet Guides",
    subtitle: "Read original, easy-to-understand guides to research products, sellers, QC, shipping and safety.",
    readMore: "Read Guide",
    featured: "Featured guide",
    comingSoon: "Coming soon",
    viewAll: "View all guides",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Frequently Asked Questions",
    subtitle: "Quick answers to the most common questions about the USFans Spreadsheet.",
    q1: "What is the USFans Spreadsheet?",
    a1: "It is an organized reference document that lists products, categories and buying details in a table, used as a starting point for research.",
    q2: "How do I use the USFans Spreadsheet?",
    a2: "Open the category you need, scan the product rows, check any QC or shipping notes, then follow the links to the main website.",
    q3: "Is USFans legit?",
    a3: "We provide independent information to help you research. Always verify current details through official sources before making a purchase.",
    q4: "Does the spreadsheet cover shipping costs?",
    a4: "Many listings include shipping-related notes, but final costs depend on weight, method and destination.",
    q5: "Do I need an account to browse?",
    a5: "Browsing resources is usually open, but always confirm account requirements on the official website.",
  },
  cta: {
    title: "Ready to Explore More?",
    subtitle: "Use our guides to research USFans, compare information and understand the most important factors before continuing to the main resource.",
    primary: "Visit Main Website",
    secondary: "Explore All Guides",
  },
  footer: {
    description: "USFansSheet is an independent informational resource centered on the USFans Spreadsheet, helping you research products, categories, QC, shipping and safety.",
    explore: "Explore",
    resources: "Resources",
    categories: "Categories",
    guides: "Guides",
    faq: "FAQ",
    mainWebsite: "Main Website",
    disclaimer: "USFansSheet.guru is an independent informational resource and is not affiliated with or officially endorsed by USFans unless explicitly stated. Always verify current information through official sources before making purchases or financial decisions.",
    rights: "All rights reserved.",
  },
  cat: {
    shoes: "Shoes",
    hoodies: "Hoodies / Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants / Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear / Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  article: {
    breadcrumbHome: "Home",
    breadcrumbGuides: "Guides",
    notFoundTitle: "Guide not found",
    notFoundDesc: "The guide you are looking for is not available. Head back to the homepage to browse all of our resources.",
    backHome: "Back to Home",
    updated: "Updated",
    relatedTitle: "Related Guides",
    ctaTitle: "Continue Your Research",
    ctaDesc: "Now that you have read this guide, you can browse the product categories or go straight to the main website to explore the full resource.",
    ctaMain: "Visit Main Website",
  },
};